import { ILaya } from "../../ILaya";
import { LayaEnv } from "../../LayaEnv";
import { NodeFlags } from "../Const";
import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { SpriteConst } from "../display/SpriteConst";
import { Filter } from "../filters/Filter";
import { LayaGL } from "../layagl/LayaGL";
import { Rectangle } from "../maths/Rectangle";
import { RenderTexture2D } from "../resource/RenderTexture2D";
import { Stat } from "../utils/Stat";
import { Context } from "./Context";
import { LayaGLQuickRunner } from "./LayaGLQuickRunner";
import { Render2DSimple } from "./Render2D";
import { SpriteCache } from "./SpriteCache";
const INIT = 0x11111;
export class RenderSprite {
    static __init__() {
        LayaGLQuickRunner.__init__();
        var initRender = new RenderSprite(INIT, null);
        let len = RenderSprite.renders.length = SpriteConst.CHILDS * 2;
        for (let i = 0; i < len; i++)
            RenderSprite.renders[i] = initRender;
        RenderSprite.renders[0] = new RenderSprite(0, null);
    }
    static _initRenderFun(sprite, context, x, y) {
        var type = sprite._renderType;
        var r = RenderSprite.renders[type] = RenderSprite._getTypeRender(type);
        r._fun(sprite, context, x, y);
    }
    static _getTypeRender(type) {
        if (LayaGLQuickRunner.map[type] && LayaEnv.isPlaying)
            return new RenderSprite(type, null);
        var rst = null;
        var tType = SpriteConst.CHILDS;
        while (tType > 0) {
            if (tType & type)
                rst = new RenderSprite(tType, rst);
            tType = tType >> 1;
        }
        return rst;
    }
    constructor(type, next) {
        this._maskRect_TextureSpace = new Rectangle();
        if (LayaGLQuickRunner.map[type] && LayaEnv.isPlaying) {
            this._fun = LayaGLQuickRunner.map[type];
            this._next = RenderSprite.NORENDER;
            return;
        }
        this._next = next || RenderSprite.NORENDER;
        switch (type) {
            case 0:
                this._fun = this._no;
                return;
            case SpriteConst.ALPHA:
                this._fun = this._alpha;
                return;
            case SpriteConst.TRANSFORM:
                this._fun = this._transform;
                return;
            case SpriteConst.BLEND:
                this._fun = this._blend;
                return;
            case SpriteConst.CANVAS:
                this._fun = this._canvas;
                return;
            case SpriteConst.MASK:
                this._fun = this._mask;
                return;
            case SpriteConst.CLIP:
                this._fun = this._clip;
                return;
            case SpriteConst.GRAPHICS:
                this._fun = this._graphics;
                return;
            case SpriteConst.CHILDS:
                this._fun = this._children;
                return;
            case SpriteConst.CUSTOM:
                this._fun = this._custom;
                return;
            case SpriteConst.TEXTURE:
                this._fun = this._texture;
                return;
            case SpriteConst.FILTERS:
                this._fun = Filter._filter;
                return;
            case SpriteConst.HITAREA:
                this._fun = this._hitarea;
                return;
            case SpriteConst.RENDERNODE2D:
                this._fun = this._renderNode2D;
                break;
            case INIT:
                this._fun = RenderSprite._initRenderFun;
                return;
        }
    }
    _renderNode2D(sprite, context, x, y) {
        if (sprite._renderNode.addCMDCall)
            sprite._renderNode.addCMDCall(context, x, y);
        context.drawLeftData();
        if (context._render2DManager._renderEnd) {
            context._render2DManager._renderEnd = false;
            context._render2DManager.addRenderObject(sprite._renderNode);
        }
        else {
            context._render2DManager.addRenderObject(sprite._renderNode);
        }
        if (this._next != RenderSprite.NORENDER)
            this._next._fun(sprite, context, x, y);
    }
    _no(sprite, context, x, y) {
    }
    _custom(sprite, context, x, y) {
        sprite.customRender(context, x, y);
        this._next._fun(sprite, context, 0, 0);
    }
    _clip(sprite, context, x, y) {
        let next = this._next;
        if (next == RenderSprite.NORENDER)
            return;
        if (sprite._getBit(NodeFlags.DISABLE_INNER_CLIPPING) && !context._drawingToTexture) {
            next._fun(sprite, context, x, y);
            return;
        }
        let r = sprite._scrollRect;
        let width = r.width;
        let height = r.height;
        if (width === 0)
            width = 0.001;
        if (height === 0)
            height = 0.001;
        context.save();
        context.clipRect(x, y, width, height);
        next._fun(sprite, context, x - r.x, y - r.y);
        context.restore();
    }
    _texture(sprite, context, x, y) {
        if (!sprite._getBit(NodeFlags.HIDE_BY_EDITOR)) {
            var tex = sprite.texture;
            if (tex._getSource()) {
                var width = sprite._isWidthSet ? sprite._width : tex.sourceWidth;
                var height = sprite._isHeightSet ? sprite._height : tex.sourceHeight;
                var wRate = width / tex.sourceWidth;
                var hRate = height / tex.sourceHeight;
                width = tex.width * wRate;
                height = tex.height * hRate;
                if (width > 0 && height > 0) {
                    let px = x - sprite.pivotX + tex.offsetX * wRate;
                    let py = y - sprite.pivotY + tex.offsetY * hRate;
                    context._material = sprite.graphics.material;
                    context.drawTexture(tex, px, py, width, height, 0xffffffff);
                    context._material = null;
                }
            }
        }
        if (this._next != RenderSprite.NORENDER)
            this._next._fun(sprite, context, x, y);
    }
    _graphics(sprite, context, x, y) {
        if (!sprite._getBit(NodeFlags.HIDE_BY_EDITOR)) {
            let g = sprite._graphics;
            g && g._render(sprite, context, x - sprite._pivotX, y - sprite._pivotY);
        }
        if (this._next != RenderSprite.NORENDER)
            this._next._fun(sprite, context, x, y);
    }
    _hitarea(sprite, context, x, y) {
        if (!context._drawingToTexture && sprite.hitArea) {
            let g = sprite.hitArea._hit;
            let temp = context.globalAlpha;
            context.globalAlpha *= 0.5;
            g && g._render(sprite, context, x - sprite._pivotX, y - sprite._pivotY);
            g = sprite.hitArea._unHit;
            g && g._render(sprite, context, x - sprite._pivotX, y - sprite._pivotY);
            context.globalAlpha = temp;
        }
        if (this._next != RenderSprite.NORENDER)
            this._next._fun(sprite, context, x, y);
    }
    _alpha(sprite, context, x, y) {
        let alpha = sprite._alpha;
        if (alpha > 0.01 || sprite._needRepaint()) {
            var temp = context.globalAlpha;
            context.globalAlpha *= alpha;
            if (this._next != RenderSprite.NORENDER)
                this._next._fun(sprite, context, x, y);
            context.globalAlpha = temp;
        }
    }
    _transform(sprite, context, x, y) {
        let transform = sprite.transform, _next = this._next;
        if (transform && _next != RenderSprite.NORENDER) {
            context.save();
            context.transform(transform.a, transform.b, transform.c, transform.d, transform.tx + x, transform.ty + y);
            _next._fun(sprite, context, 0, 0);
            context.restore();
        }
        else {
            if (_next != RenderSprite.NORENDER)
                _next._fun(sprite, context, x, y);
        }
    }
    _children(sprite, context, x, y) {
        let childs = sprite._children, n = childs.length;
        x = x - sprite.pivotX;
        y = y - sprite.pivotY;
        let textLastRender = sprite._getBit(NodeFlags.DRAWCALL_OPTIMIZE) && context.drawCallOptimize(true);
        let drawingToTexture = context._drawingToTexture;
        let rect;
        let left, top, right, bottom, x2, y2;
        if (sprite._viewport) {
            rect = sprite._viewport;
            left = rect.x;
            top = rect.y;
            right = rect.right;
            bottom = rect.bottom;
        }
        for (let i = 0; i < n; ++i) {
            let ele = childs[i];
            let visFlag = ele._getBit(NodeFlags.ACTUAL_VISIBLE);
            if (drawingToTexture && ele._getBit(NodeFlags.ESCAPE_DRAWING_TO_TEXTURE))
                visFlag = false;
            if (visFlag) {
                if (rect && ((x2 = ele._x) >= right || (x2 + ele.width) <= left || (y2 = ele._y) >= bottom || (y2 + ele.height) <= top))
                    visFlag = false;
                else if (sprite._cacheStyle.mask == ele && (!ele._getBit(NodeFlags.FORCE_VISIBLE) || drawingToTexture))
                    visFlag = false;
            }
            if (visFlag) {
                if (ele._getBit(NodeFlags.DISABLE_OUTER_CLIPPING))
                    context.clipRect(0, 0, 1, 1, true);
                ele.render(context, x, y);
            }
        }
        textLastRender && context.drawCallOptimize(false);
    }
    _renderNextToCacheRT(sprite, context, marginLeft = 0, marginTop = 0, marginRight = 0, marginBottom = 0) {
        let cache = sprite._getCacheStyle();
        if (sprite._needRepaint() || !cache.renderTexture || ILaya.stage.isGlobalRepaint()) {
            if (cache.renderTexture) {
                cache.renderTexture.destroy();
            }
            let scaleInfo = cache._calculateCacheRect(sprite, "bitmap", 0, 0);
            let tRec = cache.cacheRect;
            if (tRec.width <= 0 || tRec.height <= 0) {
                cache.renderTexture = null;
                return false;
            }
            Stat.canvasBitmap++;
            let w = tRec.width * scaleInfo.x + marginLeft + marginRight;
            let h = tRec.height * scaleInfo.y + marginTop + marginBottom;
            let rt = new RenderTexture2D(w, h, RenderTargetFormat.R8G8B8A8);
            let ctx = new Context();
            ctx.copyState(context);
            ctx.size(w, h);
            ctx.clearBG(0, 0, 0, 0);
            ctx.render2D = new Render2DSimple(rt);
            ctx.startRender();
            tRec.x -= marginLeft;
            tRec.y -= marginTop;
            this._next._fun(sprite, ctx, -tRec.x, -tRec.y);
            ctx.endRender();
            ctx.destroy();
            cache.renderTexture = rt;
            return true;
        }
        return false;
    }
    _canvas(sprite, context, x, y) {
        let cache = sprite._cacheStyle;
        let next = this._next;
        if (sprite._getBit(NodeFlags.HIDE_BY_EDITOR)) {
            next._fun(sprite, context, x, y);
            return;
        }
        let isbmp = sprite.cacheAs === 'bitmap';
        if (isbmp) {
            context.drawLeftData();
            this._renderNextToCacheRT(sprite, context);
            let tRec = cache.cacheRect;
            context._material = sprite.graphics.material;
            let rt = cache.renderTexture;
            rt && context._drawRenderTexture(rt, x + tRec.x, y + tRec.y, rt.width, rt.height, null, 1, [0, 1, 1, 1, 1, 0, 0, 0]);
            context._material = null;
        }
        else {
            if (!RenderSprite.cacheNormalEnable) {
                next._fun(sprite, context, x, y);
                return;
            }
            else {
                context.drawLeftData();
                SpriteCache.renderCacheAsNormal(context, sprite, this._next, x, y);
            }
        }
    }
    static RenderToRenderTexture(sprite, context, x, y, renderTexture = null, isDrawRenderRect = true) {
        let scaleInfo = sprite._getCacheStyle()._calculateCacheRect(sprite, "bitmap", 0, 0);
        this._transBound(sprite._cacheStyle.cacheRect, sprite.transform);
        let tRec = sprite._cacheStyle.cacheRect;
        let ctx = new Context();
        ctx._drawingToTexture = true;
        context && ctx.copyState(context);
        let rt = renderTexture;
        if (rt) {
            ctx.size(rt.width, rt.height);
            ctx.clearBG(RenderTexture2D._clearColor.r, RenderTexture2D._clearColor.g, RenderTexture2D._clearColor.b, RenderTexture2D._clearColor.a);
        }
        else {
            let w = tRec.width * scaleInfo.x + (isDrawRenderRect ? 0 : tRec.x);
            let h = tRec.height * scaleInfo.y + (isDrawRenderRect ? 0 : tRec.y);
            rt = new RenderTexture2D(w, h, RenderTargetFormat.R8G8B8A8);
            ctx.size(w, h);
            ctx.clearBG(0, 0, 0, 0);
        }
        ctx.render2D = ctx.render2D.clone(rt);
        ctx.startRender();
        if (isDrawRenderRect) {
            sprite.render(ctx, x - sprite.x - tRec.x, y - sprite.y - tRec.y);
        }
        else {
            sprite.render(ctx, x - sprite.x, y - sprite.y);
        }
        ctx.endRender();
        ctx._drawingToTexture = false;
        ctx.destroy();
        return rt;
    }
    static RenderToCacheTexture(sprite, context, x, y, isDrawRenderRect = true) {
        let cache = sprite._getCacheStyle();
        if (sprite._needRepaint() || !cache.renderTexture || ILaya.stage.isGlobalRepaint()) {
            if (cache.renderTexture) {
                cache.renderTexture.destroy();
            }
            cache.renderTexture = RenderSprite.RenderToRenderTexture(sprite, context, x, y, null, isDrawRenderRect);
            return true;
        }
        return false;
    }
    _blend(sprite, context, x, y) {
        context.save();
        context.globalCompositeOperation = sprite._blendMode;
        this._next._fun(sprite, context, x, y);
        context.restore();
    }
    static _transBound(bound, trans) {
        if (!trans || !bound)
            return;
        let a = trans.a, b = trans.b, c = trans.c, d = trans.d;
        let x1 = bound.x;
        let y1 = bound.y;
        let x2 = x1 + bound.width;
        let y2 = y1 + bound.height;
        let tx1 = x1 * a;
        let tx2 = x2 * a;
        let ty1 = y1 * c;
        let ty2 = y2 * c;
        let px1 = x1 * b;
        let px2 = x2 * b;
        let py1 = y1 * d;
        let py2 = y2 * d;
        let minX = Math.min(tx1 + ty1, tx1 + ty2, tx2 + ty1, tx2 + ty2);
        let maxX = Math.max(tx1 + ty1, tx1 + ty2, tx2 + ty1, tx2 + ty2);
        let minY = Math.min(px1 + py1, px1 + py2, px2 + py1, px2 + py2);
        let maxY = Math.max(px1 + py1, px1 + py2, px2 + py1, px2 + py2);
        bound.setTo(minX, minY, maxX - minX, maxY - minY);
    }
    _mask(sprite, ctx, x, y) {
        let mask = sprite.mask;
        if (mask._getBit(NodeFlags.FORCE_VISIBLE) && !ctx._drawingToTexture) {
            if (this._next != RenderSprite.NORENDER)
                this._next._fun(sprite, ctx, x, y);
            return;
        }
        let cache = sprite._getCacheStyle();
        if (sprite._needRepaint() || !cache.renderTexture || cache.renderTexture.destroyed || ILaya.stage.isGlobalRepaint()) {
            if (cache.renderTexture) {
                cache.renderTexture.destroy();
            }
            cache._calculateCacheRect(sprite, "bitmap", 0, 0);
            spRect_TS.copyFrom(cache.cacheRect);
            if (spRect_TS.width <= 0 || spRect_TS.height <= 0)
                return;
            spRect_TS.x += sprite.pivotX;
            spRect_TS.y += sprite.pivotY;
            let maskcache = mask._getCacheStyle();
            maskcache._calculateCacheRect(mask, "bitmap", 0, 0);
            RenderSprite._transBound(maskcache.cacheRect, mask.transform);
            let maskRect_TS = this._maskRect_TextureSpace.copyFrom(maskcache.cacheRect);
            maskRect_TS.x += mask._x;
            maskRect_TS.y += mask._y;
            let x1 = Math.max(spRect_TS.x, maskRect_TS.x);
            let y1 = Math.max(spRect_TS.y, maskRect_TS.y);
            let x2 = Math.min(spRect_TS.x + spRect_TS.width, maskRect_TS.x + maskRect_TS.width);
            let y2 = Math.min(spRect_TS.y + spRect_TS.height, maskRect_TS.y + maskRect_TS.height);
            let width1 = x2 - x1;
            let height1 = y2 - y1;
            if (width1 <= 0 || height1 <= 0)
                return;
            RenderSprite.RenderToCacheTexture(mask, ctx, 0, 0);
            let rt = new RenderTexture2D(width1, height1, RenderTargetFormat.R8G8B8A8);
            rt._invertY = LayaGL.renderEngine._screenInvertY;
            let ctx1 = new Context();
            ctx1.clearBG(0, 0, 0, 0);
            ctx1.size(width1, height1);
            ctx1.render2D = new Render2DSimple(rt);
            ctx1.startRender();
            ctx1._drawingToTexture = ctx._drawingToTexture;
            this._next._fun(sprite, ctx1, sprite.pivotX - x1, sprite.pivotY - y1);
            ctx1._drawingToTexture = false;
            let maskRT = maskcache.renderTexture;
            ctx1.globalCompositeOperation = 'mask';
            ctx1._drawRenderTexture(maskRT, maskRect_TS.x - x1, maskRect_TS.y - y1, maskRect_TS.width, maskRect_TS.height, null, 1, [0, 1, 1, 1, 1, 0, 0, 0]);
            ctx1.endRender();
            ctx1.destroy();
            cache.renderTexture = rt;
            cache.cacheRect.x = x1 - sprite.pivotX;
            cache.cacheRect.y = y1 - sprite.pivotY;
            cache.cacheRect.width = rt.width;
            cache.cacheRect.height = rt.height;
        }
        let tex = cache.renderTexture;
        let rect = cache.cacheRect;
        ctx._drawRenderTexture(tex, x + rect.x, y + rect.y, tex.width, tex.height, null, 1, [0, 1, 1, 1, 1, 0, 0, 0]);
    }
}
RenderSprite.cacheNormalEnable = true;
RenderSprite.renders = [];
RenderSprite.NORENDER = new RenderSprite(0, null);
const spRect_TS = new Rectangle();
const maskRect_TS = new Rectangle();
